import { render } from "./RemindAction.vue?vue&type=template&id=b403b4f6&scoped=true"
import script from "./RemindAction.vue?vue&type=script&lang=js"
export * from "./RemindAction.vue?vue&type=script&lang=js"

import "./RemindAction.vue?vue&type=style&index=0&id=b403b4f6&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b403b4f6"]])

export default __exports__